import { SidebarContext } from "@components:Sidebar/Sidebar.Context";
import {
  SidebarMenu,
  SidebarMenuProps,
} from "@components:Sidebar/Sidebar.Menu";
import {
  SidebarMenuItem,
  SidebarMenuItemProps,
} from "@components:Sidebar/Sidebar.MenuItem";
import {
  SidebarSubMenu,
  SidebarSubMenuProps,
} from "@components:Sidebar/Sidebar.SubMenu";
import { Box, SxProps } from "@mui/material";
import { FC, ReactNode } from "react";

import { Layout } from "@:constants";

interface Sidebar {
  children: ReactNode;
  width?: number;
  collapseWidth?: string;
  isCollapse?: boolean;
  sx?: SxProps;
  itemBackgroundColor?: string;
  itemTextColor?: string;
  itemContrastTextColor?: string;
  subHeaderTextColor?: string;
}

interface SidebarComponent extends FC<Sidebar> {
  Menu: FC<SidebarMenuProps>;
  MenuItem: FC<SidebarMenuItemProps>;
  SubMenu: FC<SidebarSubMenuProps>;
}

export const Sidebar: SidebarComponent = ({
  children,
  width = Layout.SidebarWidth - 35,
  collapseWidth = "80px",
  isCollapse = false,
  sx,
  subHeaderTextColor = "#2b2b2b",
  itemBackgroundColor = "#5c6677",
  itemTextColor = "#000000",
  itemContrastTextColor = "#ffffff",
}: Sidebar) => {
  const toggleWidth = isCollapse ? collapseWidth : width;
  return (
    <Box
      className="Sidebar"
      sx={{
        width: toggleWidth,
        flexShrink: 0,
        ...sx,
      }}
    >
      <Box
        sx={{
          width: toggleWidth,
        }}
      >
        <SidebarContext.Provider
          value={{
            width,
            collapseWidth,
            isCollapse,
            itemBackgroundColor,
            subHeaderTextColor,
            itemTextColor,
            itemContrastTextColor,
          }}
        >
          {children}
        </SidebarContext.Provider>
      </Box>
    </Box>
  );
};

Sidebar.Menu = SidebarMenu;
Sidebar.MenuItem = SidebarMenuItem;
Sidebar.SubMenu = SidebarSubMenu;
